<template>
  <main-template>
    <template v-slot:main>

      <div class="page_top">
        <h1 class="title catalog-title">Каталог</h1>
        <bread-crumbs
            :navigation-data="[
                {name: 'Главная', route: 'main'},
                {name: 'Каталог', route: 'catalog'},
            ]">
        </bread-crumbs>
      </div>


      <div class="page_content">
        <div class="main_section" v-for="section in sectionsData" :key="section">
          <img :src="section.image">
          <div class="right">
            <span
                @click="navigate(section)"
                class="section_name"
            >{{section.name}}</span>

            <div class="sub_section" :class="[{active: sub_section.show_ss_sections}]"
                 v-for="sub_section in section.sub_sections" :key="sub_section">
              <div class="sub_section_dd">
                <span @click="navigate(sub_section)" class="sub_section_name">{{sub_section.name}}</span>
                <svg
                    v-show="sub_section.sub_sub_sections != null && sub_section.sub_sub_sections.length > 0"
                    @click="function(){sub_section.show_ss_sections = !sub_section.show_ss_sections}" xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                  <rect width="17" height="16" rx="4" fill="white"/>
                  <path d="M8.5 10L6 6L11 6L8.5 10Z" fill="#222222"/>
                </svg>
              </div>
              <div class="sub_sub_sections_list" v-show="sub_section.sub_sub_sections != null && sub_section.show_ss_sections">
                <span
                    v-for="sub_sub_section in sub_section.sub_sub_sections" :key="sub_sub_section"
                    @click="navigate(sub_sub_section)"
                    class="item"
                >
                  {{sub_sub_section.name}}
                </span>
              </div>
            </div>

          </div>
        </div>
      </div>

    </template>
  </main-template>
</template>

<script>
// @ is an alias to /src
import MainTemplate from '@/components/MainTemplate.vue';
import BreadCrumbs from "@/components/share/BreadCrumbs";
import axios from 'axios';



export default {
  name: 'CatalogView',
  components: {
    BreadCrumbs,
    MainTemplate,
  },
  data() {
    return{
      sectionsData : []
    }
  },
  async mounted() {
    let res = await axios.get(window.api_url + "catalog/main");
    this.sectionsData = res.data.data;
  },
  methods : {
    navigate : function(section) {
      this.$router.push(
          {
            name:'catalog_section',
            params: {section: section.code}
          }
      )
    }
  }
}
</script>

<style scoped>
.page_content {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-row-gap: 30px;
  grid-column-gap: 20px;
}

.main_section {
  display: flex;
  gap: 12px;
}

.main_section img {
  width: 48px;
  height: 48px;
}

.main_section .right {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.main_section .section_name {
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
  cursor: pointer;
}

.sub_section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sub_section .sub_section_dd {
  display: flex;
  align-items: end;
  gap: 8px;
  cursor: pointer;
}

.sub_section .sub_section_dd svg {
  cursor: pointer;
}

.main_section .sub_section_name {
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  flex: 1;
}

.sub_section.active .sub_section_name {
  color: var(--Blue, #1B78BC);
}

.section_name:hover {
  color: var(--Blue, #1B78BC);
}

.sub_section:hover .sub_section_name {
  color: var(--Blue, #1B78BC);
}

.sub_section .sub_sub_sections_list span:hover {
  color: var(--Blue, #1B78BC);
}

.sub_section.active svg {
  transform: rotate(180deg);
}

.sub_section.active svg rect{
  fill: rgba(27, 120, 188, 0.15);
}

.sub_section.active svg path{
  fill: #1B78BC;
}

.sub_sub_sections_list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-left: 12px;
}

.sub_sub_sections_list .item {
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  cursor: pointer;
}



/*MOBILE*/
@media (max-width: 1250px)
{
  .page_top {
    flex-direction: column-reverse;
    align-items: flex-start;
    gap: 20px;
    margin-bottom: 20px;
  }

  .page_content {
    grid-template-columns: 1fr;
  }

  .main_section .sub_section_name {
    flex: unset;
  }
}
</style>

<style>

main:has(.catalog-title) {
  background: var(--White) !important;
}

</style>
